export const normalizeFloorLabel = (label = '') => {
  const normalized = String(label).trim().toLowerCase();
  if (!normalized) return '';
  if (normalized === 'roof' || normalized === 'r') return 'r';
  return normalized;
};

export const getCurrentFloorLayerSrc = (map, currentFloor, layerKey) => {
  if (!map || !currentFloor || !layerKey) return null;

  const layers = map[layerKey];
  if (!Array.isArray(layers)) return null;

  const currentLabel = normalizeFloorLabel(currentFloor.label);
  const matchingLayer = layers.find((layer) => {
    if (!layer || !layer.label) return false;
    return normalizeFloorLabel(layer.label) === currentLabel;
  });

  return matchingLayer ? matchingLayer.src : null;
};

export const getCurrentFloorCalloutSrc = (map, currentFloor) => {
  return getCurrentFloorLayerSrc(map, currentFloor, 'callouts');
};
